import { render, staticRenderFns } from "./EnacAtplDashboardPhaseItems.vue?vue&type=template&id=5b3cf265"
import script from "./EnacAtplDashboardPhaseItems.vue?vue&type=script&lang=js"
export * from "./EnacAtplDashboardPhaseItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports